export default 'availableAssets'
